"use client";

import "./globals.css";
import { Toaster } from "sonner";
import "react-day-picker/dist/style.css";
import { Poppins } from "next/font/google";
import { ThemeProvider } from "@/components/theme-provider";
import { TimezoneProvider } from "@/components/timezone-provider";
import { SessionProvider } from "next-auth/react";
import Header from "@/features/components/shared/header";
import Footer from "@/features/components/shared/footer";

const poppins = Poppins({
  variable: "--font-poppins",
  subsets: ["latin"],
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  style: ["normal", "italic"],
  display: "swap",
});

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="en" className="dark" suppressHydrationWarning>
      <body
        className={`antialiased ${poppins.className} bg-background text-foreground`}
      >
        <TimezoneProvider>
          <ThemeProvider
            attribute="class"
            defaultTheme="dark"
            enableSystem
            disableTransitionOnChange
          >
            <SessionProvider>
              <div className="bg-black min-h-screen text-white">
                <Header />
                {children}
                <Footer />
              </div>
            </SessionProvider>
            <Toaster position="top-center" richColors closeButton={true} />
          </ThemeProvider>
        </TimezoneProvider>
      </body>
    </html>
  );
}
